import apiRoutes from '../../../../../setup/consts/apiRoutes';
import { makeMutationFn } from '../../../../../utils/reactQuery';
import { SettlementDetailsResponseType } from './types';

export const GET_SETTLEMENT_DETAILS = makeMutationFn<
  undefined,
  SettlementDetailsResponseType
>(apiRoutes.SETTLEMENT_DETAILS);
